import firebase from "../../firebase";

export default function({ officeId, meaningButtons }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "pagingAdmin",
        funcName: "addMeaningButtonsToOffice",
        data: { officeId, meaningButtons }
    });
}
